// Vue 3 核心：导入 createApp 而非 Vue 构造函数
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/css/main.css";
import "font-awesome/css/font-awesome.min.css";
import { aesEncrypt, aesDecrypt } from "./utils/aes";
import axios from "./utils/axios";
import store from "./store"; // 导入修复后的 Vuex 4 store
import { loadVisibility } from "./utils/visibility";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 1. 创建 Vue 3 应用实例
const app = createApp(App);

// 2. Vue 3 中扩展全局属性（替代 Vue.prototype）
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$aesEncrypt = aesEncrypt;
app.config.globalProperties.$aesDecrypt = aesDecrypt;

// 3. 全局数据/方法处理：Vue 3 中没有 new Vue 的 data 选项，改用 provide 提供全局变量
app.provide("no_validateTips", "请输入（*）中的必填内容！");

// 4. 挂载路由、store 插件
app.use(router);
app.use(store);
app.use(ElementPlus)

// 5. 预热板块可见性配置（公开接口，失败用缓存）
loadVisibility(axios);

// 6. 挂载应用到 DOM 节点（替代 $mount 链式调用）
app.mount("#app");
